import NavBar from "./components/NavBar";
import { Routes, Route, useLocation } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Home from "./pages/Home";
import About from "./pages/About";
import Footer from "./components/Footer/Footer";
import Contact from "./pages/Contact";
import AlpomServ from "./pages/AlpomServ";
import Cookies from 'js-cookie';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import IconSo from "./components/IconSo";

const languages = [
    {
        code: 'ar',
        name: 'عربي',
        country_coode: 'sa',
        dir: 'rtl'
    },
    {
        code: 'en',
        name: 'English',
        country_coode: 'gb',
        dir: 'ltr'
    }
]
function App() {

    const currentLanguageCode = Cookies.get('i18next') || 'ar';
    console.log("🚀 ~ file: App.js:35 ~ App ~ currentLanguageCode:", currentLanguageCode)
    const currentLanguage = useMemo(() => languages.find(l => l.code === currentLanguageCode), [currentLanguageCode])
    console.log("🚀 ~ file: App.js:41 ~ App ~ currentLanguage:", currentLanguage)
    const { t } = useTranslation();
    useEffect(() => {

        document.dir = currentLanguage.dir || 'rtl';
        document.getElementsByTagName('html')[0].setAttribute('lang', currentLanguage.code || 'ar');
        // document.title = t('app_title'); 
    }, [currentLanguage, t]);
    const ScrollToTop = () => {
        const { pathname } = useLocation();

        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    };
    return (
        <div className="App">
            <CssBaseline />
            <NavBar />

            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/service" element={<AlpomServ />} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;
